import React from "react";
import Modal from "../Modal.jsx";
import { siteConfig } from '../../variables/config'
import CustomDropZone from "../CustomDropZone.jsx";
import { imageAddress, translate } from "../../utils/useful.js";

class ProfileImageInput2 extends React.Component {

    state = {
        images: [],
        files: [],
        oldImages: null
    }

    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data != this.props.data) {
            // this.init()
        }
    }

    init = () => {
        // console.log(this.props.data)

        if (this.props.data) {
            let data = JSON.parse(JSON.stringify(this.props.data))
            // console.log(Array.isArray(data) ? data : [data])
            this.setState({ oldImages: Array.isArray(data) ? data : [data] })
        } else {
            this.setState({ oldImages: null })
        }
    }


    showImage(imageAddress) {
        this.setState({ selectedImage: imageAddress })
        // console.log('imageAddress', imageAddress)
        // this.props?.changeValue('selectedImage', this.state.images[0])
        this.props.openModal('imageModal')
    }

    render() {
        let info = this.props.header.information
        // console.log(this.state.oldImages)
        return (
            <div className="d-flex">

                <div className="">

                    {(this.state.images?.length > 0 || this.state.oldImages?.length > 0) ? (
                        <div className="position-relative flexcc">
                            <div className="h-100">
                                {this.state.oldImages && Array.isArray(this.state.oldImages) && this.state.oldImages.map((prop, index) => {
                                    return (
                                        <div className="flexcc" key={index}>
                                            <img className="br-50" width={60} height={60} onClick={() => this.showImage(imageAddress(prop))} src={imageAddress(prop, 'small')} />
                                        </div>
                                    )
                                })}

                                {this.state.images.map((prop, index) => {
                                    return (
                                        <div className="flexcc" key={index}>
                                            <img className="br-50" width={60} height={60} onClick={() => this.showImage(prop)} src={prop} />
                                        </div>
                                    )
                                })}
                            </div>
                            <div className="position-absolute flexc">
                                {/* <CustomDropZone information={info} onDrop={this.changeImage}>
                                    <button className="flexcc p-2 br-10" style={{ backgroundColor: " rgba(255, 255, 255, 0.6)" }}>
                                        <img width={18} src="/assets/icons/messenger/change-blue.svg" />
                                    </button>
                                </CustomDropZone> */}

                                <button className="flexcc p-1 br-50" style={{ backgroundColor: " rgba(255, 255, 255, 0.6)" }} onClick={() => { this.removeOldFile(0) }}>
                                    <img width={20} className="opacity-7" src="/assets/icons/trash-black.svg" />
                                </button>
                            </div>
                        </div>
                    ) : (


                        <CustomDropZone information={info} onDrop={this.chooseImage}>
                            <div className="cursor-pointer">
                                <div className="position-relative flexcc">
                                    {/* <img className="br-50" width={70} height={70} src={'/assets/icons/messenger/group-image.svg'} /> */}
                                    <div className="flexcc p-2 br-100" style={{ width: '60px', height: '60px', backgroundColor: "#f2f4f6" }}>
                                        <div className=" flexc p-2 br-50" style={{ backgroundColor: "#d3d5d7" }}>
                                            <img width={18}  className="opacity-7" src="/assets/icons/useful/images-2.png" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CustomDropZone>


                    )}





                </div>

            </div>
        );
    }



    chooseImage = (newFiles, newImages) => {

        let images = newImages
        let files = newFiles

        this.setState({ images, files })
        console.log('images is', images)
        console.log('files is', files)
        this.props.changeValue('selectedImage', files, () => {
        })
        // this.props.changeFiles(files, this.props.header?.key, 'image')

    }


    changeImage = (newFiles, newImages) => {

        // let images = this.state.images
        // let files = this.state.files
        // files = files.concat(newFiles)
        // images = images.concat(newImages)

        let images = newImages
        let files = newFiles

        this.setState({ images, files, oldImages: null })
        this.props.changeValue(this.props.header?.key, null, this.props.extra)
        // this.props.changeFiles(files, this.props.header?.key, 'image')

    }


    removeOldFile(index) {
        var oldImages = this.state.oldImages
        console.log(oldImages)
        // if (oldImages?.length > 0) {
        oldImages = null //.splice(index, 1)
        this.setState({ oldImages })
        this.props.changeValue(this.props.header?.key, oldImages, this.props.extra)
        setTimeout(() => {
            this.removeFile()
        }, 50);

        // }
    }



    removeFile(key, index) {
        var images = this.state.images
        var files = this.state.files
        // if (images?.length > 0) {
        images = []//.splice(index, 1)
        files = []//.splice(index, 1)
        this.setState({ images, files })
        setTimeout(() => {
            // this.props.changeFiles(null, this.props.header?.key, 'file')
        })
        // }

    }
}

export default ProfileImageInput2;
